export default __webpack_public_path__ + "static/media/theme_krimi.0d4b49f7.jpg";